import { AppContext } from "@/contexts/appContexts";
import { getCategoryData } from "@/utils/category";
import { buildCanonicalUrl } from "@/utils/canonical";
import { useContext } from "react";
import SEO from "../../seo";
import BreadCrumb from "@/components/Category/BreadCrumb";
import Banners from "./banners";
import { useRouter } from "next/router";
import useClient from "@/hooks/global/useClient";
import { usePathname } from "next/navigation";
import Skeleton from "@/components/Skeleton";

const CategoryHead = ({ id, device, cat: catProp }) => {
  const { categoryData } = useContext(AppContext);
  // SSR-resolved value wins; fall back to the client tree for SPA navigation.
  const cat = catProp?.id
    ? catProp
    : getCategoryData(categoryData?.children_data, "id", id);

  const { isClient } = useClient();
  const { locale, asPath } = useRouter();
  const pathname = usePathname();

  const isMainCategory = pathname.split("/")?.length === 2;
  const cleanPath = asPath.split("?")[0].split("#")[0];

  const catFullPath = buildCanonicalUrl(cleanPath, locale);

  return (
    <div className="">
      <div className="w-[80%] max-[570px]:w-[98%] mx-auto mt-6">
        <SEO
          title={cat?.meta_title || cat?.name}
          description={cat?.meta_description || ""}
          imageUrl="https://imgs.dev-almanea.com/media/wysiwyg/logo/logo.png"
          pathname={cleanPath}
          isPLP={true}
        >
          <link rel="canonical" href={catFullPath} />
        </SEO>

        {!isClient && isMainCategory ? (
          <Skeleton className=" aspect-[1440/350] rounded-lg" />
        ) : (
          <Banners
            banners={cat?.banners?.[device] || []}
            img={cat?.category_desktop_image1}
            name={cat?.name}
          />
        )}
      </div>
      <BreadCrumb />
    </div>
  );
};

export default CategoryHead;
